import fb from '@/services/firebase.js'
import router from '../../router'

export const namespaced = true

export const state = {
  loading: false
}

export const mutations = {
  SET_LOADING(state, value) {
    state.loading = value
  }
}

export const actions = {
  complete({ commit }, detail) {
    commit('SET_LOADING', true)
    fb.auth.onAuthStateChanged(user => {
      var new_details = detail
      new_details.phone = user.phoneNumber
      fb.db
        .collection('users')
        .doc(user.uid)
        .set(new_details)
        .then(() => {
          router.push({
            name: 'Dashboard'
          })
        })
      commit('SET_LOADING', false)
    })
  }
}

export const getters = {}
